import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';

interface CancellationReasonModalProps {
  confirmLabel?: string;
  onConfirm: (reason: string) => void;
  onHide: () => void;
  show: boolean;
  title?: string;
}

const CancellationReasonModal = ({
  confirmLabel,
  onConfirm,
  onHide,
  show,
  title,
}: CancellationReasonModalProps) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (show) {
      setReason('');
    }
  }, [show]);

  return (
    <Modal
      onHide={onHide}
      show={show}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title || t('cancelReasonPrompt')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <label
          className="form-label"
          htmlFor="cancel-reason"
        >
          {t('cancelReason')}
        </label>
        <textarea
          className="form-control"
          id="cancel-reason"
          onChange={event => setReason(event.target.value)}
          placeholder={t('cancelReasonPlaceholder')}
          rows={3}
          value={reason}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={onHide}
          variant="outline-secondary"
        >
          {t('cancel')}
        </Button>
        <Button
          onClick={() => onConfirm(reason.trim())}
          variant="danger"
        >
          {confirmLabel || t('confirmCancellation')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CancellationReasonModal;
